import React from "react"
import { View, Text, TextLink } from "react-ame-components"

export class TextLinkExample extends React.Component {
  render() {
    return (
      <View padding="medium">
        <Text target="title-large">TextLink</Text>
        <View marginTop="nano">
          <Text fontSize="nano">
            Um texto com um{" "}
            <TextLink onPress={() => console.log("press")}>link</TextLink>
          </Text>
        </View>
      </View>
    )
  }
}
